import { Navigate, useParams } from "react-router-dom";
import { PATHS } from "@/lib/router";
import { OnboardingPage } from "./pages";

const VALID_PROJECTS = new Set(["nxplan", "nxmap", "esg"]);

const OnboardingRoute = () => {
  const { project = "" } = useParams();
  const hasProject =
    typeof project === "string" &&
    project.length > 0 &&
    VALID_PROJECTS.has(project.toLowerCase());

  if (!hasProject) {
    return <Navigate to={PATHS.NOT_FOUND} />;
  }

  return <OnboardingPage />;
};

export const onboardingRoutes = [
  {
    path: `${PATHS.ONBOARD}/:project?`,
    element: <OnboardingRoute />,
    handle: {
      permission: { resource: "onboard_setup", action: "view" },
      blacklistGroup: ["user"],
    },
  },
];
